import { DoDateServices } from "./Services.Interface";

const { REACT_APP_LOCAL } = process.env;
let url_base = `${REACT_APP_LOCAL}/EnterpriseServices/Sel`;
let method = "POST";
 
export interface AltaSolicitudServicioRequest {
    SolicitudDeServicio: SolicitudServicio ;
}

export interface SolicitudServicio{
    Cuenta : string,
    Area : string,
    SubArea : string,
    Descripcion : string,
    ContactoRowId : string,
    MailConfirmacion : string
    Pais: string,
    TipoCuenta : string,
    NombreSuscriptor : string,
    DatosFiscales? : DatosFiscales | undefined,
    Sistema : string,
    idSesion : string,
    Direccion? : Direccion | undefined,
    ContratacionServicios? : ContratacionServicios | undefined,
    CompraControlRemoto? : CompraControlRemoto | undefined,
    ActivaRemoteBooking? : ActivaRemoteBooking | undefined,
    InfoPPE? : InfoPPE | undefined
}

export interface DatosFiscales{
    RFC : string,
    RazonSocial : string,
    Compania : string,
    TipoFactura : string,
    MetodoEnvio : string
}

export interface Direccion {

}

export interface ContratacionServicios{
  PaqueteActual:string,
  NombreCanalALaCarta:string,
  PenalizacionVETVCA:string
}

export interface CompraControlRemoto{
  IDControlRemoto:string
}

export interface ActivaRemoteBooking{

}

export interface InfoPPE{
  TokenOverride:string
}

export interface AltaSolicitudServicioResponse {
  resultado : string,
  resultadodesc: string,
  NumeroSolicitud : string
}

export const getDataService_AltaSolicitudServicio = (
    solicitudDeServicio : AltaSolicitudServicioRequest
) => {

  const doDataServices: DoDateServices = {
    serviceName: "AltaSolicitudDeServicioRest",
    url: url_base,
    method: method,
    request: JSON.stringify(solicitudDeServicio)
  };

  return doDataServices;
};